import React, { useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/VendorStats.module.css';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import {
    commonFontWeight700,
    contentStart,
    infoBorderColor,
    infoFontSize1,
} from './commonConst';
import SettlementSaleList from './SettlementSaleList';
import downChev from 'routes/vendorRe/images/down_chevron.png';
import P from 'components/P';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import { requester } from 'App';
import VendorSaleList from 'routes/vendorRe/components/VendorSaleList';
import { useNavigate } from 'react-router-dom';

const SettlementBest = props => {
    const [isMounted, setMounted] = useState(false);
    const [weekSalesData, setWeekSalesData] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        setMounted(true);
    }, []);
    useEffect(() => {
        if (isMounted) {
            requester.getBestSalesTop3(result => {
                
                setWeekSalesData(result.data);
                // setSalesOverview(result.data);
            });
        }
    }, [isMounted]);

    const onDetailClick = () => {
        navigate('/vendor/sale');
    };
    return (
        <VerticalFlex margin="0 0 2em">
            <FlexChild alignItems={contentStart}>
                <VerticalFlex
                    backgroundColor="#fff"
                    borderRadius="1em"
                    padding="1.5em"
                >
                    <FlexChild>
                        <VerticalFlex height="auto">
                            <FlexChild>
                                <HorizontalFlex>
                                    <FlexChild width={'initial'}>
                                        <P
                                            size={infoFontSize1}
                                            weight={commonFontWeight700}
                                        >
                                            주간 판매량 BEST 3
                                        </P>
                                    </FlexChild>
                                    <FlexChild justifyContent={'flex-end'}>
                                        <P
                                            cursor
                                            onClick={onDetailClick}
                                            size={'min(3.2vw, 16px)'}
                                        >
                                            상세보기
                                        </P>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            {/* 반복 구간 시작*/}
                            {weekSalesData &&
                                weekSalesData
                                    .sort((a, b) => b.quantity - a.quantity)
                                    .map((saleItem, index) => (
                                        <VendorSaleList
                                            key={index}
                                            data={saleItem}
                                        />
                                    ))}
                            {/* 반복 구간 끝 */}
                        </VerticalFlex>
                    </FlexChild>
                </VerticalFlex>
            </FlexChild>
        </VerticalFlex>
    );
};

export default SettlementBest;
